var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58213 3.01228H3.27571C3.60997 4.24214 4.87792 4.96816 6.10778 4.6339C6.89767 4.41922 7.51472 3.80217 7.7294 3.01228H15.2001C15.542 3.01228 15.8191 2.73515 15.8191 2.39329C15.8191 2.05143 15.542 1.7743 15.2001 1.7743H7.7294C7.39514 0.544417 6.12719 -0.181611 4.89734 0.152648C4.10744 0.367335 3.4904 0.984381 3.27571 1.77427H1.58213C1.24027 1.77427 0.963139 2.0514 0.963139 2.39326C0.963139 2.73512 1.24027 3.01228 1.58213 3.01228Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2001 6.88084H13.5065C13.1729 5.65116 11.9057 4.92472 10.676 5.25829C9.88545 5.47274 9.26788 6.09028 9.05343 6.88084H1.58211C1.24025 6.88084 0.963123 7.15797 0.963123 7.49983C0.963123 7.84169 1.24025 8.11882 1.58211 8.11882H9.05343C9.38702 9.3485 10.6543 10.0749 11.884 9.74137C12.6745 9.52692 13.2921 8.90938 13.5065 8.11882H15.2001C15.542 8.11882 15.8191 7.84169 15.8191 7.49983C15.8191 7.15797 15.542 6.88084 15.2001 6.88084Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2001 11.9877H7.72939C7.39513 10.7578 6.12718 10.0318 4.89732 10.366C4.10743 10.5807 3.49038 11.1978 3.2757 11.9877H1.58211C1.24025 11.9877 0.963123 12.2648 0.963123 12.6066C0.963123 12.9485 1.24025 13.2256 1.58211 13.2256H3.2757C3.60996 14.4555 4.87791 15.1815 6.10776 14.8473C6.89766 14.6326 7.5147 14.0155 7.72939 13.2256H15.2001C15.542 13.2256 15.8191 12.9485 15.8191 12.6066C15.8191 12.2648 15.542 11.9877 15.2001 11.9877Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon2);
export default __webpack_public_path__ + "static/media/filterIcon2.c5257ede5bb326043fe97ac5ddd747cc.svg";
export { ForwardRef as ReactComponent };